
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleKey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CircleKey"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"public_key"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":58}};
    doc.loc.source = {"body":"fragment CircleKey on CircleKey {\n  key_id\n  public_key\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
